import {
  getConceptResultsForSentenceCombining
} from './sentenceCombiningLessonQuestion';
import {
  getConceptResultsForFillInTheBlanks
} from './fillInTheBlanks';

import { embedQuestionNumbers } from '../../../Shared/activityScoring';

export function getConceptResultsForQuestion(questionObj) {
  if (questionObj.type === 'SC') {
    return getConceptResultsForSentenceCombining(questionObj.question);
  } else if (questionObj.type === 'FB') {
    return getConceptResultsForFillInTheBlanks(questionObj.question);
  }
}

export function getNestedConceptResultsForAllQuestions(questions) {
  return questions.map(questionObj => getConceptResultsForQuestion(questionObj));
}

export function getQuestionScores(questions) {
  return questions.map(questionObj => questionObj.question.attempts.some(attempt => attempt.response?.optimal) ? 1 : 0);
}

export function getConceptResultsForAllQuestions(questions) {
  const nested = getNestedConceptResultsForAllQuestions(questions);
  const withKeys = embedQuestionNumbers(nested, 0, getQuestionScores(questions));
  return [].concat.apply([], withKeys); // Flatten array
}

export { calculateScoreFromConceptResults, embedQuestionNumbers } from '../../../Shared/activityScoring';
